<template>
    <div v-show="showing" class="min-h-screen bg-gradient-to-r from-purple-600 to-pink-500 p-6">
      <div class="max-w-6xl mx-auto">
        <header class="text-center mb-8">
          <h1 class="text-4xl font-extrabold tracking-tight mb-2 text-white">
            Jobs Board
          </h1>
          <p class="text-lg text-gray-200">
            Find exciting jobs to earn extra money for your travels!
          </p>
        </header>
        <div v-if="loading" class="flex justify-center items-center">
          <div class="w-16 h-16 border-4 border-t-4 border-gray-200 rounded-full animate-spin"></div>
        </div>
        <div v-else class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div
            v-for="(job, index) in jobs"
            :key="index"
            class="flex flex-col bg-white text-gray-900 p-6 rounded-lg shadow-lg transform transition hover:scale-105"
          >
            <h2 class="text-2xl font-bold mb-2 text-pink-600">
              {{ job.name }}
            </h2>
            <p class="mb-4 text-gray-700">
              {{ job.description }}
            </p>
            <ul class="mb-4 space-y-1">
              <li>
                <span class="font-semibold">Location:</span>
                ({{ job.lat }}, {{ job.lng }})
              </li>
              <li>
                <span class="font-semibold">Pay:</span>
                ${{ job.money.toFixed(2) }}
              </li>
              <li>
                <span class="font-semibold">Time:</span>
                {{ job.start }} - {{ job.end }}
              </li>
              <li>
                <span class="font-semibold">Duration:</span>
                {{ formatDuration(job.duration) }}
              </li>
              <li>
                <span class="font-semibold">Board:</span>
                {{ job.board }}
              </li>
            </ul>
            <button
              class="mt-auto bg-pink-600 hover:bg-pink-700 text-white py-2 px-4 rounded-full transition"
            >
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup>
import { ref } from 'vue';

const props = defineProps({
    jobs: {
        type: Array,
        required: true,
    },
});
  
const loading = ref(true);

const showing = defineModel('modelValue', {
    default: false,
    type: Boolean,
});
  
/**
 * Converts a duration in seconds to a string in hours and minutes.
 * For example, 14400 seconds becomes "4h 0m".
 */
function formatDuration(duration) {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    return `${hours}h ${minutes}m`;
}

</script>  